import Vue from 'vue'
import wordHighlight from './word-highlight'
import clamp from './clamp'

Vue.directive('word-highlight', wordHighlight)
Vue.directive('clamp', clamp)
